import React from "react";

/**
 * Donut — single-arc ring for the API quota gauge in ApiHealthCard.
 * Pure SVG (no recharts dependency; recharts' PieChart adds a lot of
 * machinery for what is a one-line arc).
 *
 * Props:
 *  - value:      number      arc length
 *  - max:        number      full circle == max
 *  - size:       px (default 64)
 *  - stroke:     px (default 6)
 *  - color:      arc color (default indigo-400)
 *  - trackColor: track ring color (default zinc-700/60)
 */
const Donut = ({
  value,
  max,
  size = 64,
  stroke = 6,
  color = "#818cf8",
  trackColor = "rgba(63,63,70,.6)",
}) => {
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const pct = max > 0 ? Math.min(1, value / max) : 0;
  return (
    <svg width={size} height={size} aria-hidden="true">
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={trackColor}
        strokeWidth={stroke}
      />
      <circle
        cx={size / 2}
        cy={size / 2}
        r={r}
        fill="none"
        stroke={color}
        strokeWidth={stroke}
        strokeDasharray={`${c * pct} ${c}`}
        strokeLinecap="round"
        transform={`rotate(-90 ${size / 2} ${size / 2})`}
      />
    </svg>
  );
};

export default Donut;
